import React, { useEffect } from "react";
import { Navbar } from "./components/navbar";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  useHistory,
} from "react-router-dom";
import { Home } from "../src/pages/home/index";
import { Error } from "./pages/error/index";
import { Project } from "./pages/project/index";
import { Projects } from "./pages/projects/index";
import { ScrollTop } from "./components/scrollTop/index";

function App() {
  function ScrollToTop() {
    const history = useHistory();

    useEffect(() => {
      return history.listen(() => {
        window.scrollTo(0, 0);
      });
    }, [history]);

    return null;
  }

  return (
    <Router>
      <ScrollToTop />
      <nav>
        <Navbar />
      </nav>
      <main>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/projects/:id" exact component={Project} />
          <Route path="/projects" exact component={Projects} />
          <Route path="/error" exact component={Error} />
          <Redirect from="*" to="/error" />
        </Switch>
      </main>
      <ScrollTop />
    </Router>
  );
}

export default App;
